<template>
  <div class="home">
    <head-com></head-com>
    <div class="main">
      <div class="cont bs">
        <h3 class="title">报名管理</h3>
        <div class="tabs">
          <div class="top">
            <el-select
              v-model="postId"
              size="small"
              placeholder="请选择专业"
              clearable
              @change="specialChange"
            >
              <el-option
                v-for="(item,i) in specialList"
                :key="i"
                :label="item.postName"
                :value="item.postId"
              ></el-option>
            </el-select>
            <el-select
              style="margin:0 10px"
              size="small"
              v-model="regHasCourse"
              placeholder="报名状态"
              clearable
              @change="activeState"
            >
              <el-option label="未激活" value="0"></el-option>
              <el-option label="已激活" value="1"></el-option>
            </el-select>
            <el-button type="primary" size="small" @click="onSearch">查询</el-button>
            <el-button type="success" size="small" @click="addDialog = true">新增报名</el-button>
          </div>
          <div class="table">
            <el-table
              :data="tableData"
              border
              max-height="460"
              :cell-style="cellStyle"
              v-loading="loading"
              element-loading-text="拼命加载中"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(0, 0, 0, 0.8)"
              highlight-current-row
              :header-cell-style="{background:'#dde9fc',color:'#606266'}"
            >
              <el-table-column type="index" label="序号" width="50"></el-table-column>
              <el-table-column property="regName" label="姓名" width="120"></el-table-column>
              <el-table-column property="regSex" label="性别" :formatter="sexFormat" width="80"></el-table-column>
              <el-table-column
                property="regIdcard"
                label="身份证号"
                min-width="120px"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column property="regTel" label="手机号"></el-table-column>
              <el-table-column property="postName" label="专业"></el-table-column>
              <el-table-column property="affiliatedEnterprise" label="所属企业"></el-table-column>
              <el-table-column property="regHasCourse" label="报名状态" :formatter="stateFormat"></el-table-column>
              <el-table-column fixed="right" label="操作" width="100">
                <template slot-scope="scope">
                  <el-button type="primary" size="mini" @click="deleteBtn(scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <pagination
              :currentPage="currentPage"
              :total="total"
              :limit="limit"
              ref="page"
              @handleCurrentChange="handleCurrentChange"
              @handleSizeChange="handleSizeChange"
            />
          </div>
        </div>
      </div>
      <!-- 新增报名 -->
      <el-dialog title="新增报名" :visible.sync="addDialog" width="30%" center>
        <el-form ref="form" :model="form">
          <el-form-item label="选择专业：">
            <el-select v-model="form.postId" placeholder="请选择专业" clearable>
              <el-option
                v-for="(item,i) in specialList"
                :key="i"
                :label="item.postName"
                :value="item.postId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-row style="text-align:center">
            <el-button type="primary" size="small">保存</el-button>
            <el-button size="small" @click="addDialog = false">取消</el-button>
          </el-row>
        </el-form>
      </el-dialog>
    </div>
    <footer-com></footer-com>
  </div>
</template>
<script>
import HeadCom from "@/components/Header.vue";
import FooterCom from "@/components/Footer.vue";
import pagination from "../components/pagination";
import http from "../api/module";

export default {
  name: "applyMessage",
  data() {
    return {
      loading: true,
      currentPage: 1, // 当前页
      limit: 10, // 每页显示数量
      total: 0, // 总条目数
      specialList: JSON.parse(sessionStorage.getItem("specialList")),
      postId: "",
      regHasCourse: "",
      addDialog: false,
      form: {},
      tableData: []
    };
  },
  components: {
    HeadCom,
    pagination,
    FooterCom
  },
  mounted() {
    this.registerList();
  },
  methods: {
    // 当前页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.registerList();
    },
    // 每页数
    handleSizeChange(val) {
      this.limit = val;
      this.currentPage = 1;
      this.registerList();
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 7) {
        if (row.regHasCourse == 0) {
          return "color:#F56C6C";
        } else {
          return "color:#67C23A";
        }
      } else {
        return "";
      }
    },
    sexFormat(row) {
      var regSex = row.regSex;
      if (regSex == "0") {
        return "男";
      } else {
        return "女";
      }
    },
    stateFormat(row, column) {
      var state = row.regHasCourse;
      if (state == "0") {
        return "未激活";
      } else if (state == "1") {
        return "已激活";
      }
    },
    specialChange(val) {
      this.postId = val;
    },
    activeState(val) {
      this.regHasCourse = val;
    },
    onSearch() {
      this.currentPage = 1;
      this.$refs.page.init();
      this.registerList();
    },
    registerList() {
      http
        .registerList({
          pageNum: this.currentPage,
          pageSize: this.limit,
          postId: this.postId,
          regHasCourse: this.regHasCourse
        })
        .then(data => {
          if (data.data.code == "200" || data.data.success == true) {
            this.loading = false;
            this.tableData = data.data.data;
            this.total = data.data.total;
          } else {
            this.$message.error({
              duration: 1000,
              message: data.data.message
            });
          }
        })
        .catch(error => {
          this.$message.error({
            duration: 1000,
            message: "请求失败,请联系管理员!"
          });
        });
    },
    // 删除报名信息
    deleteBtn(params) {
      console.log(params);
      var regId = params.regId;
      this.$confirm(`确定要删除吗?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          http
            .deleteRegister({
              regId: regId,
              sysDeleted: 1
            })
            .then(data => {
              if (data.data.code == "200" || data.data.success == true) {
                this.$message.success({
                  duration: 1000,
                  message: `删除成功!`
                });
                this.registerList();
              } else {
                this.$message.error({
                  duration: 1000,
                  message: data.data.message
                });
              }
            })
            .catch(error => {});
        })
        .catch(() => {
          this.$message.info({
            duration: 1000,
            message: `已取消删除!`
          });
        });
    }
  }
};
</script>
<style lang="less" scoped>
/deep/.el-dialog--center .el-dialog__body {
  padding: 20px 100px;
}
.cont {
  border-radius: 6px;
  width: 100%;
  margin: 30px 0;
  background: #ffffff;
  .title {
    font-size: 18px;
    line-height: 60px;
    border-bottom: 1px solid #ddd;
    padding: 0 20px;
    font-weight: normal;
  }
}
.tabs {
  padding: 20px;
}
.table {
  margin-top: 20px;
}
</style>